/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

//
//  @author Yakimenko Dmitry (dy@design.ru)
//  @created 29.01.2015
//  @copyright Art. Lebedev Studio (http://www.artlebedev.ru/)
//

var als = window.als || {};


/**
 * @constructor
 */

als.Search = function () {
  this.root_ = jQuery('.nav-search:not(.nav-search_home)');
  this.inputHolder_ = jQuery('.search__searchfield', this.root_);
  this.input_ = jQuery('input[type=text]', this.inputHolder_);
  this.submit_ = jQuery('button', this.root_);
  this.dist_ = jQuery('main');
  this.results_ = null;
  
  this.attachEvents_();
};

/**
 * @type {string}
 * @private
 */

als.Search.CLASS_HIDDEN = 'main-to-background';

/**
 * @type {string}
 * @private
 */

als.Search.CLASS_FOCUSED = 'focused';

/**
 * @private
 */

als.Search.prototype.attachEvents_ = function () {
  
  var t = this;
  
  this.submit_.on('click', function (e) {
    
    // закомментировано временно, т.к мешает тестам
    // на данный момент поиск работает не так, как на макетах
    //e.preventDefault();
    t.input_.val($.trim(t.input_.val()));
    if (t.input_.val().length > 0) {
      // переводим в нижний регистр
      t.input_.val(t.input_.val().toLowerCase());
      
      if (t.results_ != null)
        t.finish_();
      
      t.start_();
    } else {
      return false;
    }
    
  });
  
  jQuery(document).keyup(
    /**
     * @param {!jQuery.Event} event
     */
    function (event) {
      if (event.which === als.Keyboard.ESCAPE && t.results_ != null) {
        t.finish_();
      }
    });
  
  jQuery('body').on('click', '.js-search-close', function () {
    t.finish_();
  });
};


/**
 * @private
 */
als.Search.prototype.initTooltip_ = function () {
  var $icon = jQuery('.js-ctl-fav');
  
  $icon.on('click', function () {
    jQuery(this).toggleClass('with-icon_fav-not-active with-icon_fav-active');
  });
  
  if ($icon.length) {
    $icon.tooltip({
      position: {
        my: "left top",
        at: "right+5 top+12"
      },
      tooltipClass: "tooltip tooltip_text"
    });
  }
  
  return this;
};


/**
 * @private
 */
als.Search.prototype.start_ = function () {
  var t = this;
  
  this.inputHolder_
    .prepend('<div class="process-demo"/>')
    .find('.process-demo')
    .animate({right: 81}, 800, 'easeInExpo', function () {
      $(this).remove();
      //t.loadRes_();
    });
  
};

/**
 * @private
 */
als.Search.prototype.finish_ = function () {
  
  this.results_.remove();
  this.dist_.removeClass(als.Search.CLASS_HIDDEN);
  
  
};

/**
 * @private
 */
als.Search.prototype.loadRes_ = function () {
  var t = this;
  
  jQuery.get("../search-results/")
    .done(function (data) {
      t.results_ = jQuery(data).insertBefore(t.dist_);
      new als.Catalog(jQuery('.products', t.results_), undefined, jQuery(t.results_));
      t.initInputs_().initTooltip_().animationDemo_();
    });
  
};

/**
 * @private
 */
als.Search.prototype.initInputs_ = function () {
  jQuery('.input_amount', this.results_).each(function () {
    var min = $(this).data('min') ? $(this).data('min') : 1;
    new als.IntegerInput(
      $(this),
      {
        min: min,
        allowMousewheelChange: false,
        attachControls: true
      });
  });
  
  als.initSliderRange(jQuery('#slider-range', this.results_));
  
  return this;
};

/**
 * @private
 */
als.Search.prototype.animationDemo_ = function () {
  var t = this
    , height = t.results_.height()
    , hidden = {
    head: jQuery('.search-results__head', t.results_).css('opacity', 0),
    controls: jQuery('.search-results__aside, .side-filter', t.results_).css('opacity', 0),
    items: jQuery('.product, .catalog__button, .catalog-sort', t.results_).css('opacity', 0)
  };
  
  t.results_
    .css({position: 'absolute', height: 0, width: '100%'})
    .animate({height: height}, 800, function () {
      
      t.dist_.addClass(als.Search.CLASS_HIDDEN);
      jQuery(this).removeAttr('style');
      
      t.showInner_(hidden);
      
    });
};

/**
 * @private
 */
als.Search.prototype.showInner_ = function (hidden) {
  var time = 150
    , delay = 400;
  
  hidden.head.animate({opacity: 1}, delay, function () {
    
    hidden.controls.animate({opacity: 1}, delay, function () {
      
      hidden.items.each(function (i, item) {
        setTimeout(function () {
          jQuery(item).animate({opacity: 1}, delay);
        }, time);
        time += 100;
      })
      
    });
  });
  
};
}.call(window));